goog.provide("shadow.js.shim.module$src$svg$artwork$data_viz_svg$default");
shadow.js.shim.module$src$svg$artwork$data_viz_svg$default = shadow.js.shim.module$src$svg$artwork$data_viz_svg.default;
